/** @prettier */

import * as React from 'react';
import LinearProgress, {
  LinearProgressProps,
} from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import {useTranslation} from 'react-i18next';

/**
 * 表示待ちプログレスバー
 * @param {number} value 進捗
 * @returns
 */
function LinearProgressWithLabel(props: LinearProgressProps & {value: number}) {
  const trans = useTranslation().t; //翻訳関数

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      columnSpacing={3}>
      <Grid item xs={5}>
        <LinearProgress variant="determinate" {...props} />
      </Grid>
      <Grid item xs="auto">
        <Typography variant="body2" color="text.secondary">
          {`${Math.round(props.value)}${trans(
            'LinearProgressWithLabel.unit.percent'
          )}`}
        </Typography>
      </Grid>
    </Grid>
  );
}

/**
 * プログレスバー
 * @returns
 */
export default function LinearWithValueLabel() {
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prevProgress => {
        return prevProgress >= 100 ? 100 : prevProgress + 10;
      });
    }, 1500);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return <LinearProgressWithLabel value={progress} />;
}
